/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import LTTabs from './gridComponents/LTTabs';
import LTDetailTab from './LTDetailTab';
import LTBodyTab from './LTBodyTab';
import LTHeaderFooterTab from './LTHeaderFooterTab';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  closeTab,
  convertBlockmaptoHTML,
  replacePtoDivTag,
  convertHTMLtoBlockmap,
  getRandomNumberByInput,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import LTCommonModal from './gridComponents/LTCommonModal';
import CopyTemplateComp from './gridComponents/CopyTemplateComp';
import PreviewTemplateComp from './gridComponents/PreviewTemplateComp';
import {
  disputeTemplate,
  coverTemplate,
  collectTemplate,
  actionTypeUpdate,
  actionTypeAdd,
  pastDueInvoiceData,
  gridType,
  disputesNDCDetail,
  toPreviewSafePageNumberHtml,
} from './gridComponents/ConstantData';

import {
  TEMPLATE_NAME_REQUIRED,
  TEMPLATE_DESCRIPTION_REQUIRED,
  WINDOW_VALIDATION,
  EMAIL_SUBJECT_REQUIRED,
  PREVIOUS_TEMPLATE_VERSION_NOT,
  SUCCESSMESSAGE_GENERIC,
  SAVE_ERROR_NDC,
  CHECK_DUPLICATE_TEMPLATE_NAME,
  SAVE_FIRST_BEFORE_COPY,
  SAVE_BEFORE_PREVIEW,
  SELECT_AN_TEMPLATE,
  SELECT_MANUFACTURER,
  ERR_PAGINATE_VALUE,
  PREVIEW_ERROR_IFNOT,
  INVALID_INVOICE_NUM,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  saveLetterTemplateErrorMsgList,
  saveLetterTemplateDetailList,
  saveFetchLetterTemplateDetailList,
  getTemplateDetail,
  getPreviousTemplateVersion,
  setLetterTemplateExtraState,
  setExtraStateFromOther,
  getCreateUpdateLetterTemplate,
  getRebateProgramDestinationList,
  getInvoiceByInvoiceNumber,
  updatePreviewTemplate,
  getAllMergeFieldList,
  getAllMergeFieldListForDefaultFooter,
  getTemplateListForValidation,
  getPDFPrintPreview,
  newLetterSent,
  dispatchSaveLetterTemplate,
  getTemplateDetailWhenCopy,
  getGeneralSystemParameterDetails,
  saveLTDMergeFieldList,
  getAutoSendIndicatorValidation,
  getAllSubMergeFieldListData,
  getDRAMSInvoiceStartQtr,
  updateLetterTemplateDetailCopyList,
  clearLetterTemplatePage,
} from '../store/actions';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

const WINDOW_ADDRESS_PREVIEW_LIMITATION_MSG =
  'Preview is currently unavailable when Window Address is selected for Collection templates that contain Header merge fields. Please uncheck Window Address or proceed without preview.';

const mergeTemplateDetailSeqNums = (templateDetails, templateDetailsVOs) => {
  if (_.isEmpty(templateDetails) || _.isEmpty(templateDetailsVOs)) {
    return templateDetails;
  }

  return templateDetails.map((detailItem) => {
    const savedDetail = _.find(
      templateDetailsVOs,
      (item) => item.displayName === detailItem.displayName
    );
    if (!savedDetail?.templateDetailSeqNum) {
      return detailItem;
    }

    return {
      ...detailItem,
      templateDetailSeqNum: savedDetail.templateDetailSeqNum,
    };
  });
};

// After a successful save, drop rows already sent with tempDetRemoved /
const pruneRemovedTemplateDetails = (templateDetails) => {
  if (_.isEmpty(templateDetails)) {
    return templateDetails || [];
  }
  return _.filter(templateDetails, (l) => !l.tempDetRemoved).map((l) => ({
    ...l,
    tempDatailItems: _.filter(
      l.tempDatailItems || [],
      (si) => !si.tempdItemRemoved
    ),
  }));
};

function LetterTemplateDetailComp(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const gridRef = React.useRef();
  const fetchLetterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.fetchLetterTemplateDetail
  );
  const letterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateDetail
  );
  const letterTemplateDetailPage = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail.searchValue
  );
  const templateTypeList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.templateType
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages
  );
  const detailPageErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailPage
  );
  const detailTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailTab
  );
  const bodyTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.bodyTab
  );
  const headerTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.headerTab
  );
  const extraState = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState
  );
  const edit = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.edit
  );
  const addDefHeader = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.addDefHeader
  );
  const tabs = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.tabs
  );
  const destinationRebate = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.destinationRebate
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.extraState.fullScreenView
        .templateDetail
  );
  const allSelectedMergeField = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.allSelectedMergeField
  );
  const saveMsg = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.saveMsg
  );
  const tamplateListValidation = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.tamplateListValidation
  );
  const letterTemplateDetailCopy = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateDetailCopy
  );
  const allMergeFieldListForDefaultFooter = useSelector(
    (state) =>
      state?.sharedState?.LetterTemplateReducer
        ?.allMergeFieldListForDefaultFooter
  );
  const pdfPreview = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.pdfPreview
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const setErrorMessages = (value) =>
    dispatch(saveLetterTemplateErrorMsgList(value));
  const setFilterValueAction = (value) =>
    dispatch(saveLetterTemplateDetailList(value));
  const setExtraState = (value) => dispatch(setLetterTemplateExtraState(value));
  const getSubMergeFieldList = (value) =>
    dispatch(getAllSubMergeFieldListData(value));

  const [exportFileName, setExportFileName] = useState(
    'Letter Template Details'
  );
  const [loading, setLoading] = useState(true);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [isCopySaveOpen, setIsCopySaveOpen] = useState(false);
  const [isCopyMode, setIsCopyMode] = useState(false);
  const [isViewPreviewErr, setIsViewPreviewErr] = React.useState(false);
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState({});
  const [viewPreviousVersion, setViewPreviousVersion] = useState(false);
  const [viewCopyTemplate, setViewCopyTemplate] = React.useState(false);
  const [viewPreviewTemplate, setViewPreviewTemplate] = React.useState(false);
  const [viewPreviewFilter, setViewPreviewFilter] = React.useState({
    selectedBy: 'MfgQtr',
    rebateProgramCd: null,
    qtr: null,
    InvNum: null,
  });
  const [onSelectPrevVersion, setOnSelectPrevVersion] = React.useState(null);
  const [modalView, setModalView] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(null);
  const [LTTList, setLTTList] = useState([]);
  const [defaultHeaderMFDList, setDefaultHeaderMFDList] = React.useState([]);
  const [rebateProList, setRebateProList] = React.useState([]);
  const [filterValue, setSetFilterValue] = useState({
    templateTypeCd: null,
    rebateProgramCd: null,
    name: null,
    descr: null,
    templateId: null,
    templateVersion: 1,
  });
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  const setStateChange = React.useCallback((val) => {
    const patch = {
      ...val,
      ...(val?.edit === true ? { disableSave: false } : {}),
    };
    dispatch(setExtraStateFromOther(patch));
  }, []);

  const changeFullScreenView = (view) => {
    const dataSet = {
      ...extraState.fullScreenView,
      templateDetail: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    setErrorMessages({
      ...errorMessages,
      ...val,
    });
  };

  const afterSaveOk = (savedHtml, savedEditorState) => {
    dispatch(updateLetterTemplateDetailCopyList([]));
    const savedDetail = saveMsg?.detail || {};
    const createdNewVersionFromUsed = letterTemplateDetailPage?.usedInd === 1;
    const nextUsedInd = createdNewVersionFromUsed
      ? 0
      : letterTemplateDetailPage?.usedInd;
    const restoredBody =
      savedEditorState?.body ||
      (savedHtml?.body
        ? convertHTMLtoBlockmap(savedHtml.body)
        : letterTemplateDetailPage.body);
    const restoredHeader =
      savedEditorState?.header ||
      (savedHtml?.header
        ? convertHTMLtoBlockmap(savedHtml.header)
        : letterTemplateDetailPage.header);
    const restoredFooter =
      savedEditorState?.footer ||
      (savedHtml?.footer
        ? convertHTMLtoBlockmap(savedHtml.footer)
        : letterTemplateDetailPage.footer);

    const nextTemplateId =
      savedDetail.templateId ?? letterTemplateDetailPage.templateId;
    const nextTemplateVersion =
      savedDetail.templateVersion ?? letterTemplateDetailPage.templateVersion;

    setFilterValueAction({
      ...letterTemplateDetail,
      searchValue: {
        ...letterTemplateDetailPage,
        templateId: nextTemplateId,
        templateVersion: nextTemplateVersion,
        usedInd: nextUsedInd,
        body: restoredBody,
        header: restoredHeader,
        footer: restoredFooter,
      },
      detail: {
        ...letterTemplateDetail.detail,
        templateId:
          savedDetail.templateId ?? letterTemplateDetail.detail?.templateId,
        templateVersion:
          savedDetail.templateVersion ??
          letterTemplateDetail.detail?.templateVersion,
        usedInd: createdNewVersionFromUsed
          ? 0
          : letterTemplateDetail.detail?.usedInd,
      },
      templateDetails: pruneRemovedTemplateDetails(
        mergeTemplateDetailSeqNums(
          letterTemplateDetail.templateDetails,
          savedDetail.templateDetailsVOs
        )
      ),
    });
    setSetFilterValue((prev) => ({
      ...prev,
      ...letterTemplateDetailPage,
      templateId: nextTemplateId,
      templateVersion: nextTemplateVersion,
      usedInd: nextUsedInd,
    }));
    setStateChange({ edit: false });
    setIsCopyMode(false);
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => {
        return x.navTo === '/letterTemplateDetail' && x.isRefresh;
      }).length > 0
    ) {
      const newObj = localStore.map((item) => {
        if (item.navTo === '/letterTemplateDetail') {
          item.isRefresh = true;
        }
        return item;
      });
      dispatch(getGeneralSystemParameterDetails());
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
    // dispatch(dispatchSaveLetterTemplate([]))
  };

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  // after save msg
  React.useEffect(() => {
    let errorMsg = '';
    const errorMsgList = [];
    let isError = false;
    if (saveMsg && !_.isEmpty(saveMsg)) {
      setLoading(false);
      if (saveMsg.message === 'SUCESS' && saveMsg.status === '001') {
        dispatch(
          saveLTDMergeFieldList({
            body: [],
            header: [],
            footer: [],
          })
        );
        afterSaveOk(saveMsg.savedHtml, saveMsg.savedEditorState);
        // errorMsg = SUCCESSMESSAGE_GENERIC;
        // isError = true;
        errorMsgList.push({ id: 'sucessMsg', message: SUCCESSMESSAGE_GENERIC });
        setErrorStateChange({ detailPage: _.uniqBy(errorMsgList, 'id') });
      } else {
        isError = true;
        errorMsg = SAVE_ERROR_NDC;
      }
    }
    setModalView(isError);
    setIsErrorMsg(errorMsg);
  }, [saveMsg]);

  // Tab highlighter POC
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/letterTemplateDetail' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/letterTemplateDetail') {
          if (
            edit &&
            (!_.isEmpty(detailPageErrorMessages) ||
              !_.isEmpty(detailTabErrorMessages) ||
              !_.isEmpty(bodyTabErrorMessages) ||
              !_.isEmpty(headerTabErrorMessages))
          ) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [
    edit,
    detailPageErrorMessages,
    detailTabErrorMessages,
    bodyTabErrorMessages,
    headerTabErrorMessages,
  ]);

  // Refresh Page---
  React.useEffect(() => {
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/letterTemplateDetail' && x.isRefresh;
      }).length > 0
    ) {
      dispatch(saveFetchLetterTemplateDetailList([]));
      setStateChange({ edit: false });
      setErrorMessages({
        ...errorMessages,
        detailPage: [],
        detailTab: [],
        bodyTab: [],
        headerTab: [],
      });
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/letterTemplateDetail') {
          item.isRefresh = false;
        }
        return item;
      });
      dispatch(getGeneralSystemParameterDetails());
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
    return () => {
      dispatch(clearLetterTemplatePage());
    };
  }, []);

  React.useEffect(() => {
    if (letterTemplateDetailPage && !_.isEmpty(letterTemplateDetailPage)) {
      setLoading(false);
      setSetFilterValue(letterTemplateDetailPage);
      setKeyValue({
        TEMPLATE_ID: letterTemplateDetailPage.templateId,
        TEMPLATE_VERSION: letterTemplateDetailPage.templateVersion,
      });
      if (
        letterTemplateDetailPage.rebateProgramCd !==
          filterValue.rebateProgramCd &&
        letterTemplateDetailPage.templateTypeCd !== filterValue.templateTypeCd
      ) {
        const filterVal = {
          rebateProgramCd: letterTemplateDetailPage.rebateProgramCd,
          templateTypeCd: [letterTemplateDetailPage.templateTypeCd],
        };
        dispatch(getTemplateListForValidation(filterVal));
      }
      if (
        filterValue?.templateTypeCd !== letterTemplateDetailPage.templateTypeCd
      ) {
        dispatch(
          getAllMergeFieldList({
            templateTypeCd: ['ALL', letterTemplateDetailPage.templateTypeCd],
          })
        );
        dispatch(
          getAllMergeFieldListForDefaultFooter({
            templateTypeCd: ['ALL', ...extraState.templeType],
          })
        );
        if (letterTemplateDetailPage?.templateTypeCd === disputeTemplate) {
          dispatch(
            getAutoSendIndicatorValidation({
              rebateProgramCd: letterTemplateDetailPage?.rebateProgramCd,
              templateTypeCd: [disputeTemplate],
            })
          );
        }
        if (letterTemplateDetailPage?.templateTypeCd === collectTemplate) {
          dispatch(
            getDRAMSInvoiceStartQtr({
              rebateProgCode: letterTemplateDetailPage?.rebateProgramCd,
            })
          );
        }
      }
      dispatch(dispatchSaveLetterTemplate([]));
    }
  }, [letterTemplateDetailPage]);

  React.useEffect(() => {
    const list = !_.isEmpty(templateTypeList)
      ? _.union(
          [{ id: 'ALL', name: 'All Letters' }],
          _.map(templateTypeList, (val) => ({
            id: val.codeValueID.codeValue,
            name: val.shortDescription,
          }))
        )
      : [];
    setLTTList(list);
  }, [templateTypeList]);

  React.useEffect(() => {
    if (letterTemplateDetailCopy && !_.isEmpty(letterTemplateDetailCopy)) {
      setLoading(false);
      const changeData = {
        templateId:
          letterTemplateDetailCopy?.actionType === 'Add'
            ? null
            : letterTemplateDetailCopy?.detail?.templateId,
        templateVersion:
          letterTemplateDetailCopy?.actionType === 'Add'
            ? 1
            : (letterTemplateDetailCopy?.maxTemplateVersion ||
                letterTemplateDetailCopy?.detail?.templateVersion) + 1,
      };
      const newData = {
        ...letterTemplateDetailCopy,
        actionType: letterTemplateDetailCopy?.actionType,
        searchValue: {
          ...letterTemplateDetailCopy.searchValue,
          ...changeData,
        },
        detail: {
          ...letterTemplateDetailCopy.detail,
          ...changeData,
        },
      };
      if (letterTemplateDetailCopy.actionType !== 'Add') {
        setIsCopyMode(true);
      } else {
        setIsCopyMode(false);
      }
      setFilterValueAction({ ...newData });
      dispatch(updateLetterTemplateDetailCopyList([]));
    }
  }, [letterTemplateDetailCopy]);

  // check detail reponse and redirect on detail page
  React.useEffect(() => {
    if (!_.isEmpty(fetchLetterTemplateDetail)) {
      setFilterValueAction(fetchLetterTemplateDetail);
    }
  }, [fetchLetterTemplateDetail]);

  // for Cover Letter when we create as new then add few content as default in header editor
  const getAllSubMergeFieldList = async (mfData, smfl) => {
    const newSMF = [];
    if (mfData && !_.isEmpty(mfData)) {
      const SMF = await Promise.resolve(
        getSubMergeFieldList({
          templateMetaDataSeqNum: mfData.templateMetaDataSeqNum,
        })
      );
      if (SMF && !_.isEmpty(SMF)) {
        SMF.forEach((item) => {
          item.tempdItemRemoved = false;
          if (smfl !== 0) {
            if (item.templateMetaDataItemSeqNum === smfl) {
              newSMF.push(item);
            }
          } else {
            newSMF.push(item);
          }
          return item;
        });
      }
    }
    return newSMF;
  };

  const getAllMergeFieldListInRedux = React.useCallback(
    async (count, arryArg) => {
      const mfd = !_.isEmpty(letterTemplateDetail.templateDetails)
        ? [...letterTemplateDetail.templateDetails]
        : [];
      if (count < arryArg.length) {
        const item = arryArg[count];
        const ranNum = getRandomNumberByInput(1)[0];
        const list = _.isEmpty(mfd)
          ? []
          : _.filter(mfd, (l) => {
              if (l.displayName && l.displayName !== '') {
                const res = l.displayName.replace(/[0-9]/g, '');
                return res === item.description;
              }
            });
        const num = list.length + 1;
        item.key = ranNum;
        item.displayName = `${item.description}${num}`;
        item.page = 'header';
        item.tempDetRemoved = false;
        let selectedSMF = 0;
        if (item.templateMetaDataSeqNum === 4) {
          selectedSMF = 7;
        }
        const SMF = await getAllSubMergeFieldList(item, selectedSMF);
        if (SMF && !_.isEmpty(SMF)) {
          item.tempDatailItems = !_.isEmpty(SMF) ? SMF : [];
          arryArg[count] = item;
          getAllMergeFieldListInRedux(count + 1, arryArg);
        }
      }
      if (count === arryArg.length) {
        setDefaultHeaderMFDList(arryArg);
      }
    },
    []
  );

  React.useEffect(() => {
    if (
      allMergeFieldListForDefaultFooter &&
      !_.isEmpty(allMergeFieldListForDefaultFooter) &&
      addDefHeader
    ) {
      let MFL = _.filter(allMergeFieldListForDefaultFooter, (l) =>
        _.includes([10, 4, 5, 12], l.templateMetaDataSeqNum)
      );
      setStateChange({ addDefHeader: false });
      if (MFL && !_.isEmpty(MFL)) {
        setLoading(true);
        MFL = _.orderBy(MFL, ['templateMetaDataSeqNum'], ['asc']);
        const newMFD = _.cloneDeep(MFL);
        getAllMergeFieldListInRedux(0, newMFD);
      }
    }
  }, [addDefHeader, allMergeFieldListForDefaultFooter]);

  React.useEffect(() => {
    if (!_.isEmpty(defaultHeaderMFDList)) {
      setLoading(false);
      let mfd = !_.isEmpty(letterTemplateDetail.templateDetails)
        ? [...letterTemplateDetail.templateDetails]
        : [];
      mfd = !_.isEmpty(mfd)
        ? _.concat([...mfd], [...defaultHeaderMFDList])
        : [...defaultHeaderMFDList];
      const InvHe = [];
      const tDate = [];
      const selQtr = [];
      const invNo = [];
      _.map(defaultHeaderMFDList, (item) => {
        const smf = item.tempDatailItems[0];
        if (smf.templateMetaDataSeqNum === 10) {
          InvHe.push(item);
        }
        if (smf.templateMetaDataSeqNum === 4) {
          tDate.push(item);
        }
        if (item.templateMetaDataSeqNum === 5) {
          selQtr.push(item);
        }
        if (item.templateMetaDataSeqNum === 12) {
          invNo.push(item);
        }
      });
      const headerContent = convertHTMLtoBlockmap(
        `<p style="text-align:center; font-size: 14px; font-family: Arial">{${InvHe[0]?.displayName}}</p>
        <p style="text-align:right; font-size: 10px; font-family: Arial">As of:             {${tDate[0]?.displayName}}&nbsp;<br/>Current Quarter:      {${selQtr[0]?.displayName}}<br/>Invoice Number:        {${invNo[0]?.displayName}}</p>`
      );
      const newObj = {
        searchValue: {
          ...letterTemplateDetailPage,
          header: headerContent,
        },
        detail: {
          ...letterTemplateDetail.detail,
          header: headerContent,
        },
        templateDetails: mfd,
      };

      setFilterValueAction({
        ...letterTemplateDetail,
        ...newObj,
      });
      setDefaultHeaderMFDList([]);
      setLoading(false);
    }
  }, [defaultHeaderMFDList]);

  const filterAction = React.useCallback(
    (isDetailPage = true, flType, value) => {
      const updatedSearchValue = {
        ...letterTemplateDetailPage,
        [flType]: value,
      };

      setFilterValueAction({
        ...letterTemplateDetail,
        searchValue: updatedSearchValue,
      });

      setSetFilterValue(updatedSearchValue);
      setStateChange({ edit: true });
      setIsCancelOpen(false);
    },
    [letterTemplateDetail, letterTemplateDetailPage]
  );

  const enableSaveCancelBtn = React.useCallback(
    (flType) => {
      let errorMsg = detailPageErrorMessages || [];
      if (!_.isEmpty(errorMsg)) {
        errorMsg = _.filter(errorMsg, (l) => l.id !== 'sucessMsg');
      }

      const hasErrors =
        !_.isEmpty(errorMsg) ||
        !_.isEmpty(detailTabErrorMessages) ||
        !_.isEmpty(bodyTabErrorMessages) ||
        !_.isEmpty(headerTabErrorMessages);

      if (flType === 'Save') {
        const isEnable = !extraState?.disableSave && edit && !hasErrors;
        return !isEnable;
      }
      if (flType === 'Cancel') {
        if (!isEnablebyRole) {
          return true;
        }
        return !edit;
      }
    },
    [
      edit,
      extraState?.disableSave,
      detailPageErrorMessages,
      detailTabErrorMessages,
      bodyTabErrorMessages,
      headerTabErrorMessages,
      isEnablebyRole,
    ]
  );

  const onCancel = React.useCallback(() => {
    setLoading(true);
    let addDefHeader1 = false;
    dispatch(updateLetterTemplateDetailCopyList([]));
    if (letterTemplateDetail.actionType === actionTypeUpdate) {
      dispatch(
        getTemplateDetail({
          actionType: 'Update',
          data: {
            templateId: letterTemplateDetail.detail.templateId,
            templateVersion: letterTemplateDetail.detail.templateVersion,
          },
        })
      );
    }
    if (letterTemplateDetail.actionType === actionTypeAdd) {
      setFilterValueAction({
        ...letterTemplateDetail,
        searchValue: letterTemplateDetail.detail,
        templateDetails: [],
      });
      if (letterTemplateDetail.detail.templateTypeCd === coverTemplate) {
        addDefHeader1 = true;
      }
    }
    dispatch(
      setExtraStateFromOther({
        edit: false,
        addDefHeader: addDefHeader1,
        disableSave: false,
      })
    );
    setIsCopyMode(false);
    setErrorMessages({
      ...errorMessages,
      detailPage: [],
      detailTab: [],
      bodyTab: [],
      headerTab: [],
    });
    setIsCancelOpen(false);
  }, [letterTemplateDetail]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const onSave = React.useCallback(
    (isClose) => {
      let tempNamePass = true;
      let tempDescPass = true;
      let windowPosPass = true;
      let emailSubjPass = true;
      let errorMsg = detailPageErrorMessages || [];
      const errorMsg1 = detailTabErrorMessages || [];
      if (!_.isEmpty(errorMsg)) {
        errorMsg = _.filter(errorMsg, (l) => l.id !== 'sucessMsg');
      }
      if (!_.isEmpty(letterTemplateDetailPage)) {
        if (
          _.isNull(letterTemplateDetailPage.name) ||
          _.isNaN(letterTemplateDetailPage.name) ||
          letterTemplateDetailPage.name === ''
        ) {
          errorMsg.push({ id: 'name', message: TEMPLATE_NAME_REQUIRED });
          tempNamePass = false;
        }
        if (
          _.isNull(letterTemplateDetailPage.descr) ||
          _.isNaN(letterTemplateDetailPage.descr) ||
          letterTemplateDetailPage.descr === ''
        ) {
          errorMsg.push({
            id: 'descr',
            message: TEMPLATE_DESCRIPTION_REQUIRED,
          });
          tempDescPass = false;
        }
        if (letterTemplateDetailPage.windowAddrInd === 1) {
          if (
            _.isNull(letterTemplateDetailPage.windowAddrPos) ||
            _.isNaN(letterTemplateDetailPage.windowAddrPos) ||
            letterTemplateDetailPage.windowAddrPos === ''
          ) {
            errorMsg1.push({ id: 'windowAddrPos', message: WINDOW_VALIDATION });
            windowPosPass = false;
          }
        }
        if (letterTemplateDetailPage.mediaCd !== 'PRINT') {
          if (
            _.isNull(letterTemplateDetailPage.emailSubject) ||
            _.isNaN(letterTemplateDetailPage.emailSubject) ||
            letterTemplateDetailPage.emailSubject === ''
          ) {
            errorMsg1.push({
              id: 'emailSubject',
              message: EMAIL_SUBJECT_REQUIRED,
            });
            emailSubjPass = false;
          }
        }
      }
      let list = [];
      if (letterTemplateDetailPage.templateTypeCd !== 'COVER') {
        list = !_.isEmpty(tamplateListValidation)
          ? _.filter(
              tamplateListValidation,
              (l) =>
                l.name === letterTemplateDetailPage.name &&
                l.templateVersion === 1 &&
                !l.usedInd &&
                l.templateId !== letterTemplateDetailPage.templateId
            )
          : [];
      }

      if (
        tempNamePass &&
        tempDescPass &&
        windowPosPass &&
        emailSubjPass &&
        _.isEmpty(detailTabErrorMessages) &&
        _.isEmpty(bodyTabErrorMessages) &&
        _.isEmpty(headerTabErrorMessages)
      ) {
        if (_.isEmpty(list)) {
          // setLoading(true);
          const bodyCon = letterTemplateDetailPage.body
            ? convertBlockmaptoHTML(letterTemplateDetailPage.body)
            : '';
          const headerCon = toPreviewSafePageNumberHtml(
            letterTemplateDetailPage.header
              ? convertBlockmaptoHTML(letterTemplateDetailPage.header)
              : ''
          );
          const footerCon = toPreviewSafePageNumberHtml(
            letterTemplateDetailPage.footer
              ? convertBlockmaptoHTML(letterTemplateDetailPage.footer)
              : ''
          );
          const data = {
            ...letterTemplateDetailPage,
            body: bodyCon,
            header: headerCon,
            footer: footerCon,
            lastUpdateUserId: logInUser,
            lastUpdateDt: moment().format('YYYYMMDDHHmm'),
          };
          const templateDetailsItemVOs = [];
          let templateDetailsVOs = [];
          if (
            letterTemplateDetail.templateDetails &&
            !_.isEmpty(letterTemplateDetail.templateDetails)
          ) {
            templateDetailsVOs = _.filter(
              letterTemplateDetail.templateDetails,
              (l) => l.templateDetailSeqNum || !l.tempDetRemoved
            );
            templateDetailsVOs = _.map(
              _.cloneDeep([...templateDetailsVOs]),
              (mv) => {
                const {
                  newDesc,
                  page,
                  tempDatailItems,
                  templateDetailItems,
                  ...rest
                } = mv;
                if (mv.tempDatailItems && !_.isEmpty(mv.tempDatailItems)) {
                  const subMerge = _.map(mv.tempDatailItems, (sv) => ({
                    ...sv,
                    columnHeading: sv.columnHeading,
                    columnName: sv.columnName,
                    columnWidth: sv.columnWidth,
                    displayTypeCd: sv.displayTypeCd,
                    displayOrder: sv.displayOrder || sv.itemOrder,
                    itemOrder: sv.displayOrder || sv.itemOrder,
                    lastUpdateDt: data.lastUpdateDt,
                    lastUpdateUserID: data.lastUpdateUserID,
                    sumInd: sv.sumInd,
                    tempdItemRemoved: sv.tempdItemRemoved,
                  }));

                  templateDetailsItemVOs.push({
                    ...rest,
                    tempDatailItems: subMerge,
                  });
                  let groupBy = null;
                  let orderBy = null;
                  const groupBySMF = _.filter(
                    subMerge,
                    (l) => l.groupByInd === 1
                  );
                  if (!_.isEmpty(groupBySMF)) {
                    const groupByMap = _.map(groupBySMF, (v) => v.columnName);
                    groupBy = _.join(groupByMap, ', ');
                  }

                  if (mv.displayTypeCd === gridType) {
                    const orderBySort = _.filter(subMerge, (l) => l.isSelected);
                    const orderBySMF = _.filter(orderBySort, (l) => l.isSort);
                    if (!_.isEmpty(orderBySMF)) {
                      let orderByMap = _.orderBy(
                        orderBySMF,
                        ['orderNum'],
                        ['asc']
                      );

                      orderByMap = _.map(orderByMap, (v) => {
                        return `${v.columnName} ${v.orderType}`;
                      });
                      orderBy = _.join(orderByMap, ', ');
                    } else {
                      const changeOrder = !_.isEmpty(orderBySort)
                        ? _.filter(
                            orderBySort,
                            (l) =>
                              l.templateMetaDataItemSeqNum &&
                              l.templateMetaDataSeqNum
                          )
                        : [];
                      if (!_.isEmpty(changeOrder)) {
                        rest.orderBy = orderBy;
                      }
                    }
                  }
                  if (rest.groupBy) {
                    groupBy =
                      rest.groupBy !== groupBy && groupBy
                        ? groupBy
                        : rest.groupBy;
                  }
                  if (rest.orderBy) {
                    orderBy =
                      rest.orderBy !== orderBy && orderBy
                        ? orderBy
                        : rest.orderBy;
                  }
                  return {
                    ...rest,
                    groupBy: groupBy,
                    orderBy: orderBy,
                    templateId: data.templateId,
                    lastUpdateDt: data.lastUpdateDt,
                    lastUpdateUserId: data.lastUpdateUserId,
                  };
                }
                return {
                  ...rest,
                  tempDetRemoved: true,
                  templateId: data.templateId,
                  lastUpdateDt: data.lastUpdateDt,
                  lastUpdateUserId: data.lastUpdateUserId,
                };
              }
            );
          }
          const filter = {
            templateHeaderVO: {
              templateId: data.templateId,
              templateVersion: data.templateVersion,
              templateTypeCd:
                data.templateTypeCd === 'ALL'
                  ? extraState.templeType
                  : data.templateTypeCd,
              rebateProgramCd: data.rebateProgramCd,
              name: data.name,
              descr: data.descr,
              mediaCd: data.mediaCd,
              windowAddrInd: data.windowAddrInd,
              windowAddrPos: data.windowAddrPos,
              autoSendInd: data.autoSendInd,
              usedInd: data.usedInd,
              includeWithInvoiceInd: data.includeWithInvoiceInd,
              defResponseDueInterval: data.defResponseDueInterval,
              contactTypeCd: data.contactTypeCd,
              emailSubject: data.emailSubject,
              recipientTypeCd: data.recipientTypeCd,
              body: data.body,
              header: data.header,
              footer: data.footer,
              corrLinkId: data.corrLinkId,
              lastUpdateUserId: data.lastUpdateUserId,
              lastUpdateDt: data.lastUpdateDt,
            },
            templateDetailsVOs: templateDetailsVOs,
          };
          setLoading(true);
          dispatch(
            getCreateUpdateLetterTemplate({
              filter: filter,
              templateDetailsItemVOs: templateDetailsItemVOs,
              lastUpdateUserId: logInUser,
              savedHtml: {
                body: bodyCon,
                header: headerCon,
                footer: footerCon,
              },
              savedEditorState: {
                body: letterTemplateDetailPage.body,
                header: letterTemplateDetailPage.header,
                footer: letterTemplateDetailPage.footer,
              },
            })
          );
          if (isClose) {
            closeTab('/letterTemplateDetail', history);
          }
        } else {
          setModalView(true);
          setIsErrorMsg(CHECK_DUPLICATE_TEMPLATE_NAME);
        }
        setErrorStateChange({ detailPage: _.uniqBy(errorMsg, 'id') });
      } else {
        setErrorStateChange({
          detailPage: _.uniqBy(errorMsg, 'id'),
          detailTab: _.uniqBy(errorMsg1, 'id'),
        });
      }
      setIsSaveOpen(false);
      setIsCopySaveOpen(false);
    },
    [
      letterTemplateDetailPage,
      letterTemplateDetail,
      allSelectedMergeField,
      detailPageErrorMessages,
      detailTabErrorMessages,
      bodyTabErrorMessages,
      headerTabErrorMessages,
    ]
  );

  // Close Popup POC---
  React.useEffect(() => {
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/letterTemplateDetail' && x.isFormSave;
      }).length > 0
    ) {
      _.map(updateTabs, (item) => {
        if (item.navTo === '/letterTemplateDetail' && item.isFormSave) {
          if (
            edit &&
            _.isEmpty(detailPageErrorMessages) &&
            _.isEmpty(detailTabErrorMessages) &&
            _.isEmpty(bodyTabErrorMessages) &&
            _.isEmpty(headerTabErrorMessages)
          ) {
            onSave(true);
          }
        }
        return item;
      });
    }
  }, [localStore]);

  const viewPreviousVersionAction = () => {
    if (filterValue?.templateVersion > 1) {
      if (
        filterValue.templateId !== null &&
        filterValue.templateId !== undefined &&
        filterValue.templateVersion
      ) {
        setLoading(true);
        dispatch(
          getPreviousTemplateVersion({
            templateId: filterValue.templateId,
            templateVersion: filterValue.templateVersion,
          })
        );
        setViewPreviousVersion(true);
      }
    } else {
      setIsErrorMsg(PREVIOUS_TEMPLATE_VERSION_NOT);
      setModalView(true);
    }
  };

  const onClickPreviousVersionList = (flType, row) => {
    setLoading(true);
    dispatch(
      getTemplateDetail({
        actionType: 'Update',
        data: {
          templateId: row?.templateId,
          templateVersion: row?.templateVersion,
        },
      })
    );
    setViewPreviousVersion(false);
    setStateChange({
      edit: false,
      disableSave: letterTemplateDetailPage?.usedInd === 1,
    });
  };

  const viewCopyPageAction = () => {
    if (!letterTemplateDetailPage?.templateId) {
      setIsErrorMsg(SAVE_FIRST_BEFORE_COPY);
      setModalView(true);
    } else {
      setLoading(true);
      if (_.isEmpty(destinationRebate)) {
        getRebateProgramDestinationList('Fd').then((res) =>
          setRebateProList(res)
        );
      }
      setViewCopyTemplate(true);
    }
  };

  const onClickCopyTemplate = (row) => {
    if (row && !_.isEmpty(row)) {
      if (row.list && !_.isEmpty(row.list)) {
        setLoading(true);
        setExtraState({
          ...extraState,
          edit: true,
          tabs: 'Details',
        });
        dispatch(
          getTemplateDetailWhenCopy({
            actionType:
              row.createNew === 1 &&
              row.list.templateId !== letterTemplateDetail.templateId
                ? 'Add'
                : 'Update',
            data: {
              templateId: row.list.templateId,
              templateVersion: row.list.templateVersion,
            },
            maxTemplateVersion: row.list.maxTemplateVersion,
            letterTemplateDetailPage,
          })
        );
        setViewCopyTemplate(false);
      } else {
        setIsErrorMsg(SELECT_AN_TEMPLATE);
        setModalView(true);
      }
    } else {
      setIsErrorMsg(SELECT_AN_TEMPLATE);
      setModalView(true);
    }
  };

  const previewChangeAction = (flType, val) => {
    let filter = { [flType]: val };
    if (flType === 'selectedBy') {
      filter = {
        ...filter,
        InvNum: null,
      };
    }
    setViewPreviewFilter({
      ...viewPreviewFilter,
      ...filter,
    });
  };

  const viewPreviewAction = React.useCallback(() => {
    if (edit || !letterTemplateDetailPage?.templateId) {
      setIsErrorMsg(SAVE_BEFORE_PREVIEW);
      setModalView(true);
    } else {
      let qtr = moment(moment()).quarter();
      const years = moment().format('YYYY');
      const previewFilterValue = {
        rebateProgramCd: !_.isEmpty(letterTemplateDetailPage)
          ? letterTemplateDetailPage.rebateProgramCd
          : null,
        selectedBy: 'MfgQtr',
        qtr: `${qtr}Q${years}`,
        InvNum: null,
      };
      if (userDefaults && !_.isEmpty(userDefaults)) {
        previewFilterValue.selectedBy = userDefaults.defInvoiceSelectModeCd
          ? userDefaults.defInvoiceSelectModeCd === 'IN'
            ? 'InvNum'
            : 'MfgQtr'
          : 'MfgQtr';
      }
      setViewPreviewFilter({
        ...viewPreviewFilter,

        ...previewFilterValue,
      });
      setViewPreviewTemplate(true);
    }
  }, [letterTemplateDetailPage]);

  const previewOkAction = (row) => {
    const isCollectionTemplateWithWindowAddress =
      letterTemplateDetailPage?.templateTypeCd === collectTemplate &&
      letterTemplateDetailPage?.windowAddrInd === 1;
    const activeHeaderMergeFields = _.filter(
      letterTemplateDetail?.templateDetails || [],
      (d) => d.page === 'header' && !d.tempDetRemoved
    );
    const hasDefaultHeaderMergeFields = _.some(
      activeHeaderMergeFields,
      (d) =>
        d.templateMetaDataSeqNum !== 6 &&
        (d.description || '').toUpperCase() !== 'CONTACT ADDRESS'
    );

    if (isCollectionTemplateWithWindowAddress && hasDefaultHeaderMergeFields) {
      setViewPreviewTemplate(false);
      setLoading(false);
      setIsErrorMsg(WINDOW_ADDRESS_PREVIEW_LIMITATION_MSG);
      setModalView(true);
      return;
    }

    let pass = false;
    setLoading(true);
    const request = {
      templateId: filterValue.templateId,
      templateVersion: filterValue.templateVersion,
     // userId: logInUser,
    };
    if (
      viewPreviewFilter.selectedBy === 'InvNum' &&
      viewPreviewFilter.InvNum &&
      !_.isNaN(viewPreviewFilter.InvNum)
    ) {
      dispatch(
        getInvoiceByInvoiceNumber({ invoiceNum: viewPreviewFilter.InvNum })
      );
      pass = true;
      request.invoiceNum = Number(viewPreviewFilter.InvNum);
      request.rebateProgramCd = viewPreviewFilter.rebateProgramCd;
    }
    if (
      viewPreviewFilter.selectedBy === 'MfgQtr' &&
      onSelectPrevVersion &&
      !_.isEmpty(onSelectPrevVersion)
    ) {
      dispatch(updatePreviewTemplate(onSelectPrevVersion));
      pass = true;
      request.mfgId = row.mfgId;
      request.quarter = viewPreviewFilter.qtr;
      request.rebateProgramCd = viewPreviewFilter.rebateProgramCd;
    }
    if (pass) {
      setStateChange({ tabs: 'Details' });
      setIsViewPreviewErr(true);
      dispatch(getPDFPrintPreview(request));
      dispatch(newLetterSent(request));
      setLoading(true);
    } else {
      setLoading(false);
      let msg = null;
      if (viewPreviewFilter.selectedBy === 'MfgQtr') {
        msg = SELECT_MANUFACTURER;
      }
      if (viewPreviewFilter.selectedBy === 'InvNum') {
        msg = ERR_PAGINATE_VALUE;
      }
      setIsErrorMsg(msg);
      setModalView(true);
    }
  };

  React.useEffect(() => {
    if (extraState?.previewLoading) {
      setLoading(false);
      setStateChange({ previewLoading: false });
    }
  }, [extraState?.previewLoading]);

  React.useEffect(() => {
    if (isViewPreviewErr) {
      setLoading(false);
      setIsViewPreviewErr(false);
      if (pdfPreview && pdfPreview !== '' && _.isArrayBuffer(pdfPreview)) {
        setViewPreviewTemplate(false);
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/displayLetterPreview',
          value: 'Display Letter Preview',
          isFormDirty: false,
          isFormError: false,
          isFormSave: false,
          isRefresh: true,
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        props.history.push({ pathname: '/displayLetterPreview' });
      } else {
        setIsErrorMsg(INVALID_INVOICE_NUM);
        setModalView(true);
      }
    }
  }, [pdfPreview]);

  const viewHistoryAction = () => {
    if (filterValue?.templateVersion > 1) {
      setShowViewHistory(true);
    } else {
      setIsErrorMsg(PREVIOUS_TEMPLATE_VERSION_NOT);
      setModalView(true);
    }
  };
  const onChangeFilter = (flType, value) => {
    setSetFilterValue({
      ...filterValue,
      [flType]: value,
    });
  };

  const onBlurAction = (isDetailPage = true, flType, value) => {
    const errorMsg =
      isDetailPage && !_.isEmpty(detailPageErrorMessages)
        ? _.filter(
            detailPageErrorMessages,
            (l) => !_.includes(['sucessMsg', flType], l.id)
          )
        : [];
    switch (flType) {
      case 'name':
        if (_.isNull(value) || _.isNaN(value) || value === '') {
          errorMsg.push({ id: flType, message: TEMPLATE_NAME_REQUIRED });
        }
        break;
      case 'descr':
        if (_.isNull(value) || _.isNaN(value) || value === '') {
          errorMsg.push({ id: flType, message: TEMPLATE_DESCRIPTION_REQUIRED });
        }
        break;
      default:
        break;
    }
    setErrorStateChange({ detailPage: _.uniqBy(errorMsg, 'id') });
    filterAction(isDetailPage, flType, value);
  };

  return (
    <div
      className="lettterTemplateDetail p-0"
      data-testid="letter-template-detail-component"
    >
      <SaveCancelPopup
        data-testid="letter-template-save-popup"
        open={isSaveOpen}
        title="Save"
        onConfim={() => onSave(false)}
        onCancel={() => setIsSaveOpen(false)}
      />
      <SaveCancelPopup
        data-testid="letter-template-cancel-popup"
        open={isCancelOpen}
        title="Cancel"
        onConfim={onCancel}
        onCancel={() => setIsCancelOpen(false)}
      />
      <Spinner load={loading} />
      <div className="tabs-container">
        {!fullScreenView && (
          <CustomSeparator parent1="Maintain" parent2="Letter Detail" />
        )}
        <DisplaySuccessMessages
          successMessages={
            !_.isEmpty(detailPageErrorMessages)
              ? _.filter(detailPageErrorMessages, (l) => l.id === 'sucessMsg')
                  .length > 0
                ? _.map([...detailPageErrorMessages], (l) => l.message)
                : []
              : []
          }
        />
        <DisplayErrorMessages
          data-testid="letter-template-error-msg-comp"
          errorMessages={[
            ...new Set(
              _.map(
                [
                  ..._.filter(
                    detailPageErrorMessages || [],
                    (l) => l.id !== 'sucessMsg'
                  ),
                  ...(detailTabErrorMessages || []),
                ],
                (l) => l.message
              )
            ),
          ]}
        />

        {!fullScreenView && (
          <div className="mui-custom-form no-margin custom-check">
            <fieldset
              data-testid="radio-box-component"
              className="custom-fieldset"
            >
              <legend aria-hidden="true" className="d-none" />
              <div className="row">
                <div className="col-4 mb-0">
                  <SelectBoxWithoutBoxComponent
                    data-testid="template-type-select-box"
                    labelName="Template Type"
                    required
                    select
                    disabled
                    placeholder="Please Select One"
                    optionList={LTTList || []}
                    defaultValue={filterValue?.templateTypeCd}
                  />
                  <SelectBoxWithoutBoxComponent
                    data-testid="rebate-program-select-box"
                    labelName="Rebate Program"
                    required
                    disabled
                    select={false}
                    placeholder="Please Select One"
                    defaultValue={filterValue?.rebateProgramCd}
                  />
                </div>

                <div className="col-4 mb-0">
                  <SelectBoxWithoutBoxComponent
                    data-testid="template-name-input"
                    labelName="Template Name"
                    required
                    disabled={
                      !isEnablebyRole ||
                      letterTemplateDetailPage?.templateTypeCd === 'COVER' ||
                      (letterTemplateDetailPage?.templateVersion !== 1 &&
                        letterTemplateDetailPage?.usedInd !== 1)
                    }
                    select={false}
                    isError={
                      !_.isEmpty(detailPageErrorMessages) &&
                      _.filter(detailPageErrorMessages, (l) => l.id === 'name')
                        .length
                    }
                    inputProps={{ maxlength: 30 }}
                    defaultValue={filterValue.name || ''}
                    filterAction={(e) => {
                      setStateChange({ edit: true });
                      onChangeFilter('name', e);
                    }}
                    onBlurAction={(e) => onBlurAction(true, 'name', e)}
                  />
                  <SelectBoxWithoutBoxComponent
                    data-testid="template-description-input"
                    labelName="Description"
                    required
                    disabled={!isEnablebyRole}
                    select={false}
                    isError={
                      !_.isEmpty(detailPageErrorMessages) &&
                      _.filter(detailPageErrorMessages, (l) => l.id === 'descr')
                        .length
                    }
                    inputProps={{ maxlength: 50 }}
                    defaultValue={filterValue.descr || ''}
                    filterAction={(e) => {
                      if (isEnablebyRole) {
                        setStateChange({ edit: true });
                        onChangeFilter('descr', e);
                      }
                    }}
                    onBlurAction={(e) => onBlurAction(true, 'descr', e)}
                  />
                </div>

                <div className="col-4 mb-0">
                  <SelectBoxWithoutBoxComponent
                    data-testid="template-id-input"
                    labelName="Template ID"
                    required={false}
                    disabled
                    select={false}
                    inputProps={{ maxlength: 11 }}
                    defaultValue={
                      filterValue.templateId !== null &&
                      filterValue.templateId !== undefined
                        ? filterValue.templateId
                        : ''
                    }
                  />
                  <SelectBoxWithoutBoxComponent
                    data-testid="version-input"
                    labelName="Version"
                    required
                    disabled
                    select={false}
                    inputProps={{ maxlength: 11 }}
                    defaultValue={filterValue?.templateVersion || ''}
                  />
                </div>
              </div>
            </fieldset>

            <div className="btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="saveBtn"
                  disabled={enableSaveCancelBtn('Save') || !isEnablebyRole}
                  onClick={() => {
                    if (isCopyMode) {
                      setIsCopySaveOpen(true);
                    } else {
                      setIsSaveOpen(true);
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  onClick={() => {
                    if (isEnablebyRole) {
                      setIsCancelOpen(true);
                    }
                  }}
                  disabled={enableSaveCancelBtn('Cancel')}
                  data-testid="cancelBtn"
                  className="btn btn-cancel btn btn-primary"
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        )}

        <div className="custom-check">
          <div className="float-left">
            <LTTabs
              data-testid="letter-template-tabs-comp"
              tabValue={tabs}
              handleChangeTabValue={(newValue) => {
                if (newValue === 'Details') {
                  setExportFileName('Letter Template Details');
                } else if (newValue === 'Body') {
                  setExportFileName('Letter Template Body');
                } else if (newValue === 'HeaderFooter') {
                  setExportFileName('Letter Template Header/Footer');
                }
                setStateChange({ tabs: newValue });
              }}
            />
          </div>

          <div className="float-right mt-2">
            <div className="panel-header">
              <div className="float-right th-icon-group mt-3">
                <div className="panel-header">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
                  >
                    <div className="th-icon ic-actions">
                      <PDFExportPanel
                        data-testid="template-detail-export"
                        fileName={exportFileName}
                        childRef={gridRef}
                        isExport={false}
                        addRowsView
                        addRowsTitle="View Previous Template Version"
                        onClickAddNdC={viewPreviousVersionAction}
                        viewCopyPage="Copy Template"
                        viewCopyPageAction={viewCopyPageAction}
                        viewPreview="Preview"
                        viewPreviewAction={viewPreviewAction}
                        isEnablebyRole={isEnablebyRole}
                      />
                    </div>
                  </OverlayTrigger>

                  {/* <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='history-tooltip'>View History</Tooltip>
                    }
                  >
                    <div
                      className='th-icon ic-history'
                      role='button'
                      data-testid='template-detail-history'
                      onClick={viewHistoryAction}
                      tabIndex='0'
                    >
                      <span className='ic-title'> History </span>
                    </div>
                  </OverlayTrigger> */}

                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="fullScreen-tooltip">
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                      </Tooltip>
                    }
                  >
                    <div
                      className={
                        fullScreenView
                          ? 'th-icon ic-fulScreen-exit'
                          : 'th-icon ic-fulScreen'
                      }
                      role="button"
                      data-testid="setFullScreenView"
                      onClick={() => changeFullScreenView(!fullScreenView)}
                      tabIndex="0"
                    >
                      <span className="ic-title">
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
          <div className="clearfix devider-line" />

          <div className="tabs-body">
            {tabs === 'Details' && (
              <LTDetailTab
                data-testid="template-detail-detail-tab-comp"
                filterValue={filterValue}
                filterAction={filterAction}
                isEnableSave={enableSaveCancelBtn('Save')}
                isSaveOpen={() => setIsSaveOpen(true)}
                isEnableCancel={enableSaveCancelBtn('Cancel')}
                isCancelOpen={() => setIsCancelOpen(true)}
                setErrorStateChange={setErrorStateChange}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {tabs === 'Body' && (
              <LTBodyTab
                data-testid="template-detail-body-tab-comp"
                filterAction={filterAction}
                mainFilterValue={filterValue}
                setStateChange={setStateChange}
                isEnableSave={enableSaveCancelBtn('Save')}
                isSaveOpen={() => setIsSaveOpen(true)}
                isEnableCancel={enableSaveCancelBtn('Cancel')}
                isCancelOpen={() => setIsCancelOpen(true)}
                setErrorStateChange={setErrorStateChange}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {tabs === 'HeaderFooter' && (
              <LTHeaderFooterTab
                data-testid="template-detail-headerFooter-tab-comp"
                filterAction={filterAction}
                mainFilterValue={filterValue}
                setStateChange={setStateChange}
                isEnableSave={enableSaveCancelBtn('Save')}
                isSaveOpen={() => setIsSaveOpen(true)}
                isEnableCancel={enableSaveCancelBtn('Cancel')}
                isCancelOpen={() => setIsCancelOpen(true)}
                setErrorStateChange={setErrorStateChange}
                isEnablebyRole={isEnablebyRole}
              />
            )}
          </div>
        </div>

        {showViewHistory && (
          <ViewHistoryComponent
            data-testid="template-detail-history-comp"
            setShowViewHistory={setShowViewHistory}
            tableName="TEMPLATE_HEADER"
            setSpinner={(e) => {}}
            keyValue={keyValue}
            isSpinner
          />
        )}

        <CommonModal
          data-testid="template-detail-commonModal-comp"
          open={viewPreviousVersion}
          viewAction
          viewHeader
          onOk={() => onClickPreviousVersionList('Update', onSelectPrevVersion)}
          okTitle="Ok"
          onClose={() => setViewPreviousVersion(false)}
          closeTitle="Cancel"
          modalTitle="Display Template History"
          childrenComponent={
            <LTCommonModal
              closeModal={setViewPreviousVersion}
              setLoading={setLoading}
              pageView="previousTemplateVersion"
              onSelectRow={setOnSelectPrevVersion}
              onClickAction={onClickPreviousVersionList}
            />
          }
        />

        {viewCopyTemplate && (
          <CommonModal
            data-testid="template-detail-copyTemplate-comp"
            className="dialog-420"
            open={viewCopyTemplate}
            viewAction
            viewHeader
            onOk={() => onClickCopyTemplate(onSelectPrevVersion)}
            okTitle="Ok"
            onClose={() => {
              setViewCopyTemplate(false);
              setOnSelectPrevVersion(null);
            }}
            closeTitle="Cancel"
            modalTitle="Copy Template"
            childrenComponent={
              <CopyTemplateComp
                closeModal={setViewCopyTemplate}
                setLoading={setLoading}
                pageView="copyTemplate"
                destinationRebate={rebateProList}
                onSelectRow={setOnSelectPrevVersion}
              />
            }
          />
        )}

        {viewPreviewTemplate && (
          <CommonModal
            data-testid="template-detail-previewTemplate-comp"
            className="dialog-600"
            open={viewPreviewTemplate}
            viewAction
            viewHeader
            onOk={() => previewOkAction(onSelectPrevVersion)}
            okTitle="Ok"
            onClose={() => setViewPreviewTemplate(false)}
            closeTitle="Cancel"
            modalTitle="Preview Parameters"
            childrenComponent={
              <PreviewTemplateComp
                closeModal={setViewPreviewTemplate}
                setLoading={setLoading}
                pageView="PreviewTemplate"
                filterValue={viewPreviewFilter}
                filterAction={previewChangeAction}
                onSelectRow={setOnSelectPrevVersion}
              />
            }
          />
        )}

        {modalView && isErrorMsg && (
          <CommonModal
            data-testid="template-detail-errorModal-comp"
            className="dialog-420"
            open={modalView}
            viewHeader
            viewAction
            onOk={() => {
              setIsErrorMsg(null);
              setModalView(false);
              if (isErrorMsg === SAVE_BEFORE_PREVIEW) {
                onSave(false);
              }
              if (isErrorMsg === SUCCESSMESSAGE_GENERIC) {
                onSave(false);
                // afterSaveOk();
              }
            }}
            okTitle="Ok"
            onClose={() => {
              setIsErrorMsg(null);
              setModalView(false);
            }}
            closeTitle={isErrorMsg === SAVE_BEFORE_PREVIEW ? 'Cancel' : false}
            SAVE_BEFORE_PREVIEW
            modalTitle="Warning"
            childrenComponent={<div className="p-3">{isErrorMsg}</div>}
          />
        )}
        <SaveCancelPopup
          data-testid="copy-save-confirmation-modal"
          open={isCopySaveOpen}
          title="Save"
          content="You are saving a copied version over the current version. Do you want to continue?"
          onConfim={() => {
            setIsCopySaveOpen(false);
            onSave(false);
          }}
          onCancel={() => setIsCopySaveOpen(false)}
        />
      </div>
    </div>
  );
}

export default withRouter(LetterTemplateDetailComp);
